import { render, staticRenderFns } from "./CreateSetting.vue?vue&type=template&id=b98be422&"
import script from "./CreateSetting.vue?vue&type=script&lang=js&"
export * from "./CreateSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports